import request from 'axios';
/**
 *
 * @param {*} current
 * @param {*} size
 * @param {*} params
 * @returns
 */
export const getList = (params) => {
  return request({
    url: '/lebo-resource/rabbitTactics/list',
    method: 'get',
    params: {
      ...params,
    }
  })
}
// 获取渠道数据
export const getChannelsResource = (query) => {
  return request({
    url: '/lebo-resource/common/channel/list',
    method: 'GET',
    params: query
  })
}
export const getDetail = (id) => {
  return request({
    url: '/lebo-resource/rabbitTactics/detail',
    method: 'Get',
    params: {
      id
    }
  })
}
export const remove = (id) => {
  return request({
    url: '/lebo-resource/rabbitTactics/remove',
    method: 'post',
    params: {
      id,
    }
  })
}
/**
 *
 * @param {*} id
 * @param {*} status
 * @returns
 */
export const changeStatus = (params) => {
  return request({
    url: '/lebo-resource/rabbitTactics/changeStatus',
    method: 'post',
    params
  })
}

export const add = (row) => {
  return request({
    url: '/lebo-resource/rabbitTactics/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/lebo-resource/rabbitTactics/submit',
    method: 'post',
    data: row
  })
}



